import React from 'react';
import PropTypes from 'prop-types';

import {ReportDetailsEnum} from 'common/proxies/enum-proxy';

import './index.scss';

const CardAttributes = ({asCsv, attributes}) => (
  <div className='CardAttributes'>
    {attributes.map(({label, value}) => {
      let attrDisplay = value;
      if (Array.isArray(value)) {
        if (asCsv.includes(label)) {
          attrDisplay = value.join(', ');
        } else {
          attrDisplay = value.map((item, index) => (
            <div
              className={'CardAttribute-Array'}
              key={`CardAttributeArray-${item}-${index}`}>
              {item}
            </div>
          ));
        }
      }
      return (
        <div className={'CardAttribute'} key={label}>
          <div className={'CardAttribute--Label'}>{label}</div>
          <div className={'CardAttribute--Display'}>{attrDisplay}</div>
        </div>
      );
    })}
  </div>
);

CardAttributes.propTypes = {
  asCsv: PropTypes.array,
  attributes: PropTypes.array,
};

CardAttributes.defaultProps = {
  asCsv: [
    ReportDetailsEnum.BUILDING_GROUPS.displayName,
    ReportDetailsEnum.DAYS_OF_WEEK.displayName,
  ],
  attributes: [],
};

export default CardAttributes;
